<template>
  <div :class="$style['v-message']">
    <img v-if="logo" :class="$style['logo']" :src="`https:${logo}`" />
    <h1
      :class="$style['heading']"
      v-color="colorFontHeading"
      v-font-style="fontDetailHeading"
      >{{ headingText }}</h1
    >
    <div :class="$style['detail']">
      <span v-color="colorFont" v-font-style="fontDetailBody">
        {{ detailText }}
      </span>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    logo: {
      type: String,
      default: '',
    },
    headingText: {
      type: String,
      default: '',
    },
    detailText: {
      type: String,
      default: '',
    },
    colorFontHeading: {
      type: String,
      default: '',
    },
    colorFont: {
      type: String,
      default: '',
    },
    fontDetailHeading: {
      type: Object,
      default: () => {},
    },
    fontDetailBody: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.v-message {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  margin-bottom: 30px;
}

.heading {
  margin-bottom: 16px;
}

.detail {
  margin-bottom: 30px;
}
</style>
